import React from 'react';
import { Chip } from '@mui/material';
import { LeadStatus } from '../../types/lead.types';

interface StatusChipProps {
  status: LeadStatus;
  size?: 'small' | 'medium';
}

const statusConfig: Record<LeadStatus, { label: string; color: any }> = {
  new: { label: 'New', color: 'info' },
  contacted: { label: 'Contacted', color: 'primary' },
  qualified: { label: 'Qualified', color: 'secondary' },
  proposal: { label: 'Proposal', color: 'warning' },
  negotiation: { label: 'Negotiation', color: 'default' },
  won: { label: 'Won', color: 'success' },
  lost: { label: 'Lost', color: 'error' },
};

export const StatusChip: React.FC<StatusChipProps> = ({ status, size = 'small' }) => {
  const config = statusConfig[status] || {
    label: status || 'Unknown',
    color: 'default'
  };
  
  return (
    <Chip
      label={config.label}
      color={config.color}
      size={size}
      sx={{ fontWeight: 500 }}
    />
  );
};
